module.exports = __webpack_public_path__ + "static/media/crop.ffc3fa6a.svg";